import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Button from "../../../../../components/buttons/buttons";
import Input from "../../../../../components/inputs/inputs";
import Location from "../../../../../components/includes/location";
import LocationSearch from "../../../../../components/includes/locationSearch";
import { Beat } from "../../../../../plugins/spinners.plugin";
import { XIcon } from "@heroicons/react/outline";
import { ImageCropModal } from "../../../../../components/modals/imageCropModal";
import SelectableInput from "../../../../../components/inputs/SelectableInput";
import { cleanInput } from "../../../../../helpers/cleanInput";
import {
  getOutletFromCookies,
  getToken,
  getTeamFromCookies,
} from "../../../../../utils/Auth";
import { getARestaurantAction } from "../../../../../redux/restaurant/restaurantActions";
import { filterProductCategory } from "../../../../../redux/productCatergory/productCategoryAction";
import { getAllTags } from "../../../../../redux/productTags/productTagActions";
import successHandler from "../../../../../handlers/successHandler";
import errorHandler from "../../../../../handlers/errorHandler";

export default function EditRestaurant() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outlet = getOutletFromCookies();
  const hiddenFileInput = useRef(null);
  const hiddenBannerInput = useRef(null);
  const base_url = process.env.REACT_APP_API_URL;

  const { restaurant, updating } = useSelector((state) => state.restaurant);
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { allTags } = useSelector((state) => state.productTag);
  const { settings } = useSelector((state) => state.application);
  const useGooglePlaces = settings?.google_places_status === "available";

  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [image64, setImage64] = useState({});
  const [displayCropImage, setDisplayCropImage] = useState(false);
  const [displayCropBanner, setDisplayCropBanner] = useState(false);
  const [cropSourceImageFiles, setCropSourceImageFiles] = useState([]);
  const [cropSourceBannerFiles, setCropSourceBannerFiles] = useState([]);

  const [input, setInput] = useState({
    id: outlet?.id,
    business_id: restaurant?.business_id,
    restaurant_email: restaurant?.restaurant_email,
    restaurant_name: restaurant?.restaurant_name,
    restaurant_phone: restaurant?.restaurant_phone,
    restaurant_address: restaurant?.restaurant_address,
    restaurant_description: restaurant?.restaurant_description,
    restaurant_categories: restaurant?.restaurant_categories,
    restaurant_tags: restaurant?.restaurant_tags,
    restaurant_country: restaurant?.restaurant_country,
    restaurant_city: restaurant?.restaurant_city,
    restaurant_operating_status: restaurant?.restaurant_operating_status,
    restaurant_state: restaurant?.restaurant_state,
    url_photos: restaurant?.restaurant_pictures || [],
  });
  const {
    restaurant_email,
    restaurant_name,
    restaurant_phone,
    restaurant_categories,
    restaurant_tags,
    restaurant_address,
    restaurant_description,
    restaurant_country,
    restaurant_state,
    restaurant_city,
    restaurant_operating_status,
  } = input;

  useEffect(() => {
    dispatch(getARestaurantAction(outlet?.id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (restaurant && Object.keys(restaurant).length > 0) {
      setInput((prevInput) => ({
        ...prevInput,
        ...restaurant,
        restaurant_categories: restaurant?.restaurant_categories
          ? [...restaurant.restaurant_categories] // clone it to create a new reference
          : [],
      }));
    }
  }, [restaurant]);

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  useEffect(() => {
    dispatch(getAllTags());
    dispatch(filterProductCategory({ type: "restaurant" }, 1));
    // eslint-disable-next-line
  }, []);

  const allRestaurantCategories = allCategories?.data?.filter((item) => {
    return item?.type === "restaurant";
  });
  const restaurantTags = allTags?.data?.filter((item) => {
    return item?.type === "restaurant";
  });

  //This is used to set location if google places is active
  const handleSelectLocation = (place) => {
    setInput((prev) => ({
      ...prev,
      restaurant_address: place.address,
      restaurant_city: place.city,
      restaurant_state: place.state,
      restaurant_country: place.country,
      restaurant_latitude: place.lat,
      restaurant_longitude: place.lng,
      restaurant_zip: place.postalCode,
    }));
  };

  function handleRegion(e) {
    const { name, value } = e.target;
    setInput((input) => ({ ...input, [name]: fromJson(value).name }));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleToggleTags = (value) => {
    const current = Array.isArray(input?.restaurant_tags)
      ? [...input.restaurant_tags]
      : [];

    const name = typeof value === "object" ? value.name : value;
    const exists = current.includes(name);

    const updated = exists
      ? current.filter((item) => item !== name)
      : [...current, name];

    setInput((prev) => ({ ...prev, restaurant_tags: updated }));
  };

  const handleToggleCategories = (value) => {
    const current = Array.isArray(input?.restaurant_categories)
      ? [...input.restaurant_categories]
      : [];

    const name = typeof value === "object" ? value.name : value;
    const exists = current.includes(name);

    const updated = exists
      ? current.filter((item) => item !== name)
      : [...current, name];

    setInput((prev) => ({ ...prev, restaurant_categories: updated }));
  };

  const handleRestaurantPhone = (e) => {
    let restaurant_phone = e?.slice(1);
    setInput({ ...input, restaurant_phone: restaurant_phone });
  };

  function onImageChange(e) {
    const newFiles = Array.from(e.target.files);
    setCropSourceImageFiles(newFiles);
    setImages([...images, ...e.target.files]);
    setDisplayCropImage(true);
  }

  const handleFileClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  const removeFile = (index) => {
    let newArr = images;
    newArr.splice(index, 1);
    setImages([...newArr]);
  };

  const removeUrlPhoto = (index) => {
    let newArr = [...input?.url_photos];
    newArr.splice(index, 1);
    setInput({ ...input, url_photos: newArr });
  };

  // Update cropped and previous restaurant images
  useEffect(() => {
    let newImageUrls = [];
    const newImage64 = [];
    console.log("images", images);
    images?.length > 0 &&
      images.forEach((image) => {
        if ("File" in window && image instanceof File) {
          newImageUrls.push(URL.createObjectURL(image));
          let reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onloadend = () => {
            newImage64.push(reader.result);
          };
        } else {
          newImageUrls.push(image);
        }
      });
    setImageUrls(newImageUrls);
    setImage64(newImage64);
  }, [images]);

  const [bannerArray, setBannerArray] = useState([]);
  const [bannersUrl, setBannersUrl] = useState([]);

  const handleBannerClick = (event) => {
    event.preventDefault();
    hiddenBannerInput.current.click();
  };
  const onBannerChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setCropSourceBannerFiles(newFiles);
    setBannerArray([...e.target.files]);
    setDisplayCropBanner(true);
  };

  // Update cropped and previous restaurant banner
  useEffect(() => {
    if (bannerArray.length < 1) return;
    const newImageUrls = [];
    bannerArray.forEach((image) =>
      newImageUrls.push(URL.createObjectURL(image))
    );
    setBannersUrl(newImageUrls);
  }, [bannerArray]);

  const closeCropImage = () => {
    setDisplayCropImage(false);
  };

  const closeCropBanner = () => {
    setDisplayCropBanner(false);
  };

  const handleSubmit = async () => {
    let newInput = {
      ...input,
      base64_photos: image64 ? image64 : [],
      banners: bannerArray ? bannerArray : [],
    };
    cleanInput(newInput);
    setLoading(true);
    axios
      .post(`${base_url}/api/restaurant/update`, newInput, {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data;`,
          Authorization: `Bearer ${getToken()}`,
          Team: `${getTeamFromCookies()}`,
        },
      })
      .then((response) => {
        setLoading(false);
        successHandler(response, true);
        navigate(`/admin/$${outlet?.restaurant_name}/settings/restaurant`);
      })
      .catch((error) => {
        //handle error
        setLoading(false);
        errorHandler(error, true);
      });
  };

  return (
    <div data-test="openingHours-page">
      <div className="bg-white dark:bg-[#121212] border dark:border-none w-full px-4  mx-auto sm:max-w-6xl sm:px-6 py-4 mt-8">
        <p>
          Manage your restaurant details, make changes to your restaurant
          details here.
        </p>
      </div>

      <div className="pt-8 justify-center items-center mx-auto sm:max-w-6xl">
        <div className=" p-5 w-full bg-white dark:bg-[#121212] rounded-sm border dark:border-none sm:p-8 ">
          <div className="flex justify-between items-center my-4">
            <h3 className="text-base text-gray-500 dark:text-white font-meduim flex justify-center mb-1">
              Restaurant Information
            </h3>
          </div>

          <div className="border-b mb-8"></div>

          <form className="w-full">
            <Input.Label
              title={"Restaurant Name"}
              type="text"
              name="restaurant_name"
              id="restaurant_name"
              value={restaurant_name}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter Restaurant Name"
              onChange={handleChange}
            />
            <Input.Label
              title={"Restaurant Email"}
              type="email"
              name="restaurant_email"
              id="restaurant_email"
              value={restaurant_email}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter Restaurant Email"
              onChange={handleChange}
            />
            <Input.Phone
              title={"Restaurant Phone Number"}
              name={"restaurant_phone"}
              id={"restaurant_phone"}
              defaultCountry={"NG"}
              value={restaurant_phone}
              htmlFor={"restaurant_phone"}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              onChange={handleRestaurantPhone}
            />
            <Input.Label
              title={"Restaurant Description"}
              type="text"
              name="restaurant_description"
              id="restaurant_description"
              value={restaurant_description}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter Restaurant Description"
              onChange={handleChange}
            />
            <Input.Select
              title={"Restaurant Status"}
              type="text"
              name="restaurant_operating_status"
              id="restaurant_operating_status"
              value={restaurant_operating_status}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              onChange={handleChange}
            >
              <option>
                {restaurant_operating_status ?? "Select operating status"}
              </option>
              <option value={"open"}>Open</option>
              <option value={"closed"}>Closed</option>
            </Input.Select>
            <div className="mb-4">
              <label
                htmlFor="restaurant_categories"
                className="text-sm font-medium text-[#151515] dark:text-white"
              >
                Restaurant Categories
              </label>
              <SelectableInput
                options={allRestaurantCategories}
                label="restaurant_categories"
                name={"+ Add Category"}
                type="category"
                previousSelected={restaurant_categories}
                selectOption={handleToggleCategories}
              />
            </div>

            <div>
              <label
                htmlFor="restaurant_tags"
                className="text-sm font-medium text-[#151515] dark:text-white"
              >
                Restaurant Tags
              </label>
              <SelectableInput
                options={restaurantTags}
                label="restaurant_tags"
                name={"+ Add Tag"}
                type="tag"
                previousSelected={restaurant_tags}
                selectOption={handleToggleTags}
              />
            </div>

            <Location
              country_id={locationId.country_id}
              state_id={locationId.state_id}
              city_id={locationId.city_id}
              countryList={(value) => {
                setLocationList({
                  ...locationList,
                  countryList: value,
                });
              }}
              stateList={(value) => {
                setLocationList({
                  ...locationList,
                  stateList: value,
                });
              }}
              cityList={(value) => {
                setLocationList({ ...locationList, cityList: value });
              }}
            />

            {/* Google Places or Manual Address */}
            {useGooglePlaces ? (
              <div className="my-4">
                <LocationSearch
                  onPlaceSelect={handleSelectLocation}
                  searchLocationTitle={"Search Restaurant Location*"}
                  defaultAddress={restaurant_address}
                  defaultAddressTitle={"Restaurant Address"}
                />
              </div>
            ) : (
              <Input.Label
                title={"Restaurant Address"}
                type="text"
                name="restaurant_address"
                id="restaurant_address"
                value={restaurant_address}
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Enter Restaurant Address"
                onChange={handleChange}
              />
            )}
            <div className={useGooglePlaces ? "hidden" : ""}>
              <div className="mt-6">
                <Input.Select
                  title={"Select Country"}
                  name="restaurant_country"
                  id="restaurant_country"
                  disabled={useGooglePlaces}
                  value={restaurant_country}
                  className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                  htmlFor={"restaurant_country"}
                  onChange={(e) => {
                    setLocationId({
                      ...locationId,
                      country_id: fromJson(e.target.value).id,
                    });
                    handleRegion(e);
                  }}
                >
                  <option>{restaurant_country ?? "Select Country"}</option>
                  {locationList.countryList &&
                    locationList.countryList.length > 0 &&
                    locationList.countryList.map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={toJson({
                            name: item.name,
                            id: item.id,
                          })}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                </Input.Select>
              </div>
              <div className="mt-6">
                <Input.Select
                  title={"Select State"}
                  name="restaurant_state"
                  id="restaurant_state"
                  disabled={useGooglePlaces}
                  value={restaurant_state}
                  className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                  htmlFor={"restaurant_state"}
                  onChange={(e) => {
                    setLocationId({
                      ...locationId,
                      state_id: fromJson(e.target.value).id,
                    });
                    handleRegion(e);
                  }}
                >
                  <option>{restaurant_state ?? "Select State"}</option>
                  {locationList.stateList &&
                    locationList.stateList.length > 0 &&
                    locationList.stateList.map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={toJson({
                            name: item.name,
                            id: item.id,
                          })}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                </Input.Select>
              </div>
              <div className="mt-6">
                <Input.Select
                  title={"Select City"}
                  name="restaurant_city"
                  id="restaurant_city"
                  disabled={useGooglePlaces}
                  value={restaurant_city}
                  className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                  htmlFor={"restaurant_city"}
                  onChange={(e) => {
                    setLocationId({
                      ...locationId,
                      city_id: fromJson(e.target.value).id,
                    });
                    handleRegion(e);
                  }}
                >
                  <option>{restaurant_city ?? "Select City"}</option>
                  {locationList.cityList &&
                    locationList.cityList.length > 0 &&
                    locationList.cityList.map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={toJson({
                            name: item.name,
                            id: item.id,
                          })}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                </Input.Select>
              </div>
              <div className="grid sm:grid-cols-2 gap-1 sm:gap-8 mt-6">
                <Input.Label
                  title={"Latitude"}
                  name="restaurant_latitude"
                  id="restaurant_latitude"
                  disabled={useGooglePlaces}
                  value={restaurant?.restaurant_latitude}
                  className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                  placeholder="Enter latitude"
                  onChange={handleChange}
                />

                <Input.Label
                  title={"Longitude"}
                  name="restaurant_longitude"
                  id="restaurant_longitude"
                  disabled={useGooglePlaces}
                  value={restaurant?.restaurant_longitude}
                  className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                  placeholder="Enter longitude"
                  onChange={handleChange}
                />
              </div>
            </div>
          </form>
        </div>



        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mt-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-medium">
                Restaurant Images (200px by 200px)
              </h3>
            </div>
            <>
              <button className="text-primary" onClick={handleFileClick}>
                + Upload Image
              </button>
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={onImageChange}
                ref={hiddenFileInput}
              />
            </>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-6 gap-8 mt-8">
            {input?.url_photos?.length > 0 &&
              input?.url_photos?.map((image, index) => (
                <figure className="w-full h-[160px] relative" key={index}>
                  <img
                    src={image}
                    className="object-cover w-full h-full"
                    alt="food"
                  />
                  <button
                    className="h-8 w-8 bg-[#FAE9E6] rounded-full absolute right-2 top-2"
                    onClick={() => removeUrlPhoto(index)}
                  >
                    <XIcon className="h-5 w-5 text-primary mx-auto" />
                  </button>
                </figure>
              ))}
            {imageUrls?.length > 0
              ? imageUrls?.map((image, index) => (
                <figure className="w-auto h-[160px] relative" key={index}>
                  <img
                    src={image}
                    className="w-[160px] h-[160px] object-cover"
                    alt="merchandise"
                  />
                  <button
                    className="h-8 w-8 bg-[#FAE9E6] rounded-full absolute right-2 top-2"
                    onClick={() => removeFile(index)}
                  >
                    <XIcon className="h-5 w-5 text-primary mx-auto" />
                  </button>
                </figure>
              ))
              : ""}
          </div>
        </div>

        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mt-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-medium">
                Restaurant Banner (1440px by 576px)
              </h3>
            </div>
            <>
              <button className="text-primary" onClick={handleBannerClick}>
                + Upload Banner
              </button>
              <input
                type="file"
                hidden
                className="form-control"
                onChange={onBannerChange}
                ref={hiddenBannerInput}
                multiple
              />
            </>
          </div>

          <div className="mt-8">
            {bannersUrl?.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
                {bannersUrl.map((url, index) => (
                  <figure className="w-full h-[160px] relative" key={index}>
                    <img
                      src={url}
                      className="object-cover w-[160px] h-[160px]"
                      alt="merchandise"
                    />
                  </figure>
                ))}
              </div>
            ) : (
              <p>No images</p>
            )}
          </div>
        </div>
      </div>

      <div className="flex mx-auto justify-center my-14">
        <Button.Primary
          disabled={updating || loading}
          title={loading ? <Beat color={"#ffffff"} /> : "Edit Restaurant"}
          className={"w-[160px] rounded-sm"}
          onClick={handleSubmit}
        />
      </div>
      {displayCropImage && (
        <ImageCropModal
          show={displayCropImage}
          onClose={closeCropImage}
          width={400}
          height={300}
          images={cropSourceImageFiles}
          getCroppedImages={(cropped) => {
            // Replace the last N items in the images array with cropped versions
            const updated = [...images];
            const start = updated.length - cropSourceImageFiles.length;
            updated.splice(start, cropSourceImageFiles.length, ...cropped);
            setImages(updated);
          }}
        />
      )}
      {displayCropBanner && (
        <ImageCropModal
          show={displayCropBanner}
          onClose={closeCropBanner}
          width={1440}
          height={576}
          images={cropSourceBannerFiles}
          // getCroppedImages={setImages}
          getCroppedImages={(cropped) => {
            // Replace the last N items in the images array with cropped versions
            const updated = [...images];
            const start = updated.length - cropSourceBannerFiles.length;
            updated.splice(start, cropSourceBannerFiles.length, ...cropped);
            setBannerArray(updated);
          }}
        />
      )}
    </div>
  );
}
